// https://bdq-test.xljielong.com/mkt/api/v1/swagger-ui.html#/ app2c
import axios from '@/util/request'
const prefix = '/product/api/v1'

const product = {
  withChildren (params) {
    return axios.get(
      `${prefix}/wx/toC/product/list/withChildren`,
      params
    ).then(res => res.data)
  }
}

export default product
